function getDateAsNumber(v) {
    if (v instanceof Date) {
        return v * 1;
    }
    if (v instanceof Number) {
        return new Date(v) * 1;
    }

    try {
        return Date.parse(v + '') * 1;
    }
    catch(e) {}

    return null;
}

const ObjectHasProperty = (obj, propertyName) => Object.prototype.hasOwnProperty.call(obj, propertyName);

function getItemSameByFieldFunction(idField) {
    return (i1, i2) => {
        let result = 
            (i1 != null) && 
            (i2 != null) && 
            ObjectHasProperty(i1, idField) && 
            ObjectHasProperty(i2, idField) && 
            i1[idField] == i2[idField];

        return result;
    }
}

function isTrueObject(obj) {
    let result =
        (obj instanceof Object) &&
        !(obj instanceof Array) &&
        !(obj instanceof Date) &&
        !(obj instanceof Function);
    
    return result;
}

//Returns true if object data is equals
export function IsObjectsEqualsByMap(obj1, obj2, map) {
    
    if ((obj1 === obj2) || (obj1 == null) && (obj2 == null)) {
        return true;
    }

    let result = 
        (map != null) && 
        (obj1 != null) && 
        (obj2 != null) && 
        (map instanceof Object) && 
        (obj1 instanceof Object) && 
        (obj2 instanceof Object);

    if (result) {
        for(var p in map) {
            if (ObjectHasProperty(map, p)) {
                const mp = map[p];
                const p1 = obj1[p];
                const p2 = obj2[p];

                if (typeof mp == 'boolean') {
                    result = ((p1 == null) == (p2 == null)) && (Boolean(p1) == Boolean(p2));
                }
                else if (p1 !== p2) {
                    if (mp instanceof Array) {
                        result = (p1 == null) && (p2 == null);
                        if (!result) {
                            result = (p1 instanceof Array) && (p2 instanceof Array) && (p1.length == p2.length);
                            if (result) {
                                let itemSame = mp['#itemSame'];
                                if (typeof itemSame !== 'function') {
                                    itemSame = (i1, i2) => i1 === i2;
                                }
        
                                const searchItem = (item1) => {
                                    let index = -1;
                                    p2.find((item2, i) => {
                                        if (itemSame(item1, item2)) {
                                            index = i;
                                            return true;
                                        }
                                        return false;
                                    });
                                    return index;
                                }
        
                                const itemMap = mp['#itemMap'];
                                const ignoreOrder = Boolean(mp['#ignoreOrder']);

                                for(var i1 = 0; (i1 < p1.length) && result; i1++) {
                                    if (!ignoreOrder) {
                                        result = IsObjectsEqualsByMap(p1[i1], p2[i1], itemMap);
                                    }
                                    else {
                                        const i2 = searchItem(p1);
                                        result = (i2 >= 0) && IsObjectsEqualsByMap(p1[i], p2[i2], itemMap);
                                    }
                                }
                            }
                        }
                    } 
                    else if (mp instanceof Date) {
                        const d1 = getDateAsNumber(p1); 
                        const d2 = getDateAsNumber(p2); 
                        result = (d1 == d2);
                    }
                    else if (mp instanceof Object) {
                        result = IsObjectsEqualsByMap(p1, p2, mp);
                    }
                    else { //Number, String
                        result = false;
                    }
                }
            }

            if (!result) {
                break;
            }
        }
    }

    return result;
}

export function AssignObjectDataByMap(dstObj, srcObj, map, ignoreNamesMap) {
    if (dstObj == null) {
        throw Error("Destination object can't be null");
    }

    if (!isTrueObject(dstObj)) {
        throw Error("Destination object must be instance of Object (not Array or Date).");
    }

    if (srcObj == null) {
        throw Error("Source object can't be null");
    }

    if (!isTrueObject(srcObj)) {
        throw Error("Source object must be instance of Object (not Array or Date).");
    }

    if (map == null) {
        throw Error("Map can't be null");
    }

    if (!isTrueObject(map)) {
        throw Error("Map must be instance of Object (not Array or Date).");
    }

    let isChanged = false;
    let namesMap = Boolean(ignoreNamesMap) ? null : map['#namesMap'];

    if ((namesMap != null) && !isTrueObject(namesMap)) {
        namesMap = null;
    }

    let getSourcePropName = p => p;

    if (namesMap != null) {
        getSourcePropName = p => {
            let result = p;
            
            if (ObjectHasProperty(namesMap, p)) {
                const f = namesMap[p];
                
                if (typeof f === 'string' ) {
                    result = f;
                }
            }

            return result;
        }
    }

    for (var p in map) {
        if (!ObjectHasProperty(map, p)) {
            continue;
        }

        const srcProp = getSourcePropName(p);

        if (['#namesMap', '#itemMap', '#itemSame', '#ignoreOrder'].indexOf(srcProp) >= 0) {
            continue;
        }

        //if (ObjectHasProperty(map, p) && ObjectHasProperty(srcObj, srcProp)) {
        if (ObjectHasProperty(srcObj, srcProp)) {
            const mp = map[p];
            const sp = srcObj[srcProp];

            if (sp == null) {
                isChanged = isChanged || (dstObj[p] != null);
                dstObj[p] = sp;
            }
            else {
                if (mp instanceof Array) {
                    if (sp instanceof Array) {
                        let itemSame = mp['#itemSame'];

                        if (typeof itemSame !== 'function') {
                            itemSame = (i1, i2) => i1 === i2;
                        }

                        const oldItems = dstObj[p];
                        const newArray = [];
                        let arrayChanged = (oldItems == null) || !(oldItems instanceof Array) || (oldItems.length != sp.length);
                        const ignoreOrder = Boolean(mp['#ignoreOrder']);
                        const searchItem = (oldItems != null) && (oldItems instanceof Array) && (oldItems.length > 0)
                            ?   (i1) => {
                                    let index = -1;

                                    oldItems.find((i2, i) => {
                                        if (itemSame(i1, i2)) {
                                            index = i;
                                            return true;
                                        }
                                        return false;
                                    });

                                    return index;
                                }
                            : () => -1;

                        if (mp['#itemMap'] == null) {
                            for (var i = 0; i < sp.length; i++) {
                                const srcItem = sp[i];
                                const dstItemIndex = searchItem(srcItem);

                                arrayChanged = 
                                    arrayChanged || 
                                    (dstItemIndex < 0) ||
                                    !ignoreOrder && (dstItemIndex != i);

                                newArray.push(srcItem);
                            }    
                        }
                        else {
                            for (var i = 0; i < sp.length; i++) {
                                const srcItem = sp[i];
                                let dstItem = null;

                                if (srcItem == null) {
                                    arrayChanged = arrayChanged || (oldItems[i] != null);
                                }
                                else {
                                    const dstItemIndex = searchItem(srcItem);
                                    arrayChanged = arrayChanged || (dstItemIndex < 0);
                                    dstItem = (dstItemIndex < 0) ? null : oldItems[dstItemIndex];

                                    if ((dstItem == null) || !isTrueObject(dstItem)) {
                                        dstItem = {};
                                        AssignObjectDataByMap(dstItem, srcItem, mp['#itemMap'], ignoreNamesMap);
                                        arrayChanged = true;
                                    }
                                    else {
                                        arrayChanged = arrayChanged || !ignoreOrder && (dstItemIndex != i);
                                        //Make the copy
                                        const tmpItem = {...dstItem};

                                        if (AssignObjectDataByMap(tmpItem, srcItem, mp['#itemMap'], ignoreNamesMap)) {
                                            dstItem = tmpItem;
                                            arrayChanged = true;
                                        }
                                    }
                                }

                                newArray.push(dstItem); 
                            }
                        }

                        if (arrayChanged) {
                            isChanged = true;
                            dstObj[p] = newArray;
                        }
                    }
                    else {
                        isChanged = isChanged || (dstObj[p] != null);
                        dstObj[p] = null;
                    }
                }
                else if (mp instanceof Date) {
                    const d1 = getDateAsNumber(sp); 
                    const d2 = getDateAsNumber(dstObj[p]); 
                    isChanged = isChanged || (d1 != d2);

                    if (sp instanceof Date) {
                        dstObj[p] = new Date(sp);
                    }
                    else {
                        dstObj[p] = sp;
                    }
                }
                else {
                    const pt = typeof mp;

                    switch (pt) {
                        case 'number':
                        case 'string':
                            isChanged = isChanged || (dstObj[p] !== sp);
                            dstObj[p] = sp;
                            break;
                        case 'boolean':
                            const dp = dstObj[p];
                            isChanged = isChanged || ((dp == null) != (sp == null)) || (Boolean(dp) != Boolean(sp));
                            if (sp == null) {
                                dstObj[p] = sp;
                            }
                            else {
                                dstObj[p] = Boolean(sp);
                            }
                            break;
                        case 'object':
                            if (mp == null) {
                                isChanged = isChanged || (dstObj[p] != sp);
                                dstObj[p] = sp;
                            }
                            else {
                                if (!isTrueObject(dstObj[p])) {
                                    dstObj[p] = {};
                                    AssignObjectDataByMap(dstObj[p], sp, mp, ignoreNamesMap);
                                    isChanged = true;
                                } 
                                else {
                                    // Make the copy
                                    const dp = {...dstObj[p]};
                                    
                                    if (AssignObjectDataByMap(dp, sp, mp, ignoreNamesMap)) {
                                        dstObj[p] = dp;
                                        isChanged = true;
                                    }
                                }
                            }
                            break;
                    }
                }
            }
        }
    }

    return isChanged;
}

//TODO: проверить использование этой функции
export function CreateObjectByMap(srcObj, map, ignoreNamesMap) {
    const result = {};

    AssignObjectDataByMap(result, srcObj/* || map*/, map, ignoreNamesMap);

    return result;
}

//Use only for simple JS types
export function CloneObject(srcObj, skipNullValues = false) {
    if ((typeof srcObj !== 'object') || (srcObj == null)) {
        return srcObj;
    }

    if (srcObj instanceof Date) {
        return new Date(+srcObj);
    }

    const result = (srcObj instanceof Array) ? [] : {};

    for (var p in srcObj) {
        if (srcObj[p] != null || !skipNullValues) {
            result[p] = CloneObject(srcObj[p], skipNullValues);
        }
    }

    return result;
}
